function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export var forEach = function forEach(collection) {
  var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Function.prototype;

  if (_typeof(collection) === 'object' && collection !== null) {
    Object.keys(collection).map(function (key) {
      return iteratee(collection[key], key);
    });
  }

  return collection;
};